interface FormConfiguration {
    [key: string]: Array<{
        label: string;
        value: string;
        type?: string;
        isCheckboxField?: boolean;
    }>;
}

export const formConfigurations: FormConfiguration = {
    'inceperea-executiei-lucrarilor': [
        { label: 'Autorizație emisă pentru', value: 'autorizatie_emisa_pentru' },
        { label: 'Număr autorizație', value: 'numar_autorizatie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Dată autorizație', value: 'data_autorizatie' },
        { label: 'Dată începere', value: 'data_incepere', type: 'date' },
        { label: 'Carte funciară', value: 'carte_funciara' },
        { label: 'Număr cadastral', value: 'numar_cadastral' },
        { label: 'Oră începere', value: 'ora_incepere' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
    ],
    'incetarea-executiei-lucrarilor': [
        { label: 'Autorizație emisă pentru', value: 'autorizatie_emisa_pentru' },
        { label: 'Număr autorizație', value: 'numar_autorizatie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Dată autorizație', value: 'data_autorizatie' },
        { label: 'Dată începere', value: 'data_incepere', type: 'date' },
        { label: 'Carte funciară', value: 'carte_funciara' },
        { label: 'Număr cadastral', value: 'numar_cadastral' },
        { label: 'Oră începere', value: 'ora_incepere' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
    ],
    'avizare-studiu-amplasare-mijloace-publicitare': [
        { label: 'Scop', value: 'motivatie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Dată document', value: 'data_document', type: 'date' },
    ],
    'emitere-aviz-amplasare': [
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
    ],
    'adrese-altele': [
        { label: 'Plan cadastral', value: 'plan_cadastral' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Dată începere', value: 'data_incepere', type: 'date' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Scop', value: 'motivatie' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
    ],
    'emitere-certificat-urbanism-schimbare-domiciliu': [
        // { label: 'Licitații publice', value: 'auction_details' },
        // { label: 'Alte scopuri', value: 'other_motivation_details' },
        // { label: 'Cereri în justiție', value: 'justice_details', type: 'boolean' },
        { label: 'Plan cadastral', value: 'plan_cadastral' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Suprafață', value: 'suprafata' },
        { label: 'Scop', value: 'motivatie' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },

        // Checkboxes

        // Form Documentation
        // {
        //     label: 'Lucrări de construire',
        //     value: 'formDocumentation.documentation11',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Lucrări de desfiinţare',
        //     value: 'formDocumentation.documentation12',
        //     type: 'boolean',
        // },
        // Form Documentation Options
        // {
        //     label:
        //         'Lucrări de construire, reconstruire, consolidare, modificare, extindere, reabilitare, schimbare de destinaţie sau de reparare a construcţiilor de orice fel, precum şi a instalaţiilor aferente acestora, cu excepţia celor prevăzute la art. 12 din Legea nr. 50/1991',
        //     value: 'formDocumentationOptions.documentationA',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Lucrări de construire, reconstruire, extindere, reparare, consolidare, protejare, restaurare, conservare, precum și orice alte lucrări, indiferent de valoarea lor, care urmează să fie efectuate la construcții reprezentând monumente istorice, stabilite potrivit legii',
        //     value: 'formDocumentationOptions.documentationB',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Lucrări de construire, reconstruire, modificare, extindere, reparare, modernizare și reabilitare privind căile de comunicație de orice fel, drumurile forestiere, lucrările de artă, rețelele și dotările tehnico-edilitare, lucrările hidrotehnice, amenajările de albii, lucrările de îmbuntățiri funciare, lucrările de instalații de infrastructură, lucrările pentru noi capacități de producere, transport, distribuție a energiei electrice și/sau termice, precum și de reabilitare și retehnologizare a celor existente',
        //     value: 'formDocumentationOptions.documentationC',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Împrejmuiri și mobilier urban, amenajări de spații verzi, parcuri, piețe și alte lucrări de amenajare a spațiilor publice',
        //     value: 'formDocumentationOptions.documentationD',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Lucrări de foraje și excavări necesare pentru efectuarea studiilor geotehnice și a prospecțiunilor geologice, proiectarea și deschiderea exploatărilor de cariere și balastiere, a sondelor de gaze și petrol, precum și a altor exploatări de suprafață sau subterane',
        //     value: 'formDocumentationOptions.documentationE',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Lucrări, amenajări și construcții cu caracter provizoriu, necesare în vederea organizării executării lucrărilor, în condițiile prevăzute la art. 7 alin. (11) din Legea nr. 50/1991',
        //     value: 'formDocumentationOptions.documentationF',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Organizarea de tabere de corturi, căsuțe sau rulote',
        //     value: 'formDocumentationOptions.documentationG',
        //     type: 'boolean',
        // },
        // {
        //     label:
        //         'Lucrări de construcții cu caracter provizoriu, chioșcuri, tonete, cabine, spații de expunere situate pe căile și spațiile publice, corpuri și panouri de afișaj, firme și reclame, precum și anexele gospodarești ale exploatațiilor agricole situate în extravilan',
        //     value: 'formDocumentationOptions.documentationH',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Cimitire - noi și extinderi',
        //     value: 'formDocumentationOptions.documentationI',
        //     type: 'boolean',
        // },
        // Form Operation
        // {
        //     label: 'Vânzări',
        //     value: 'formOperation.operationsA',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Cumpărări',
        //     value: 'formOperation.operationsB',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Concesionări',
        //     value: 'formOperation.operationsC',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Cesionări',
        //     value: 'formOperation.operationsD',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Dezmembrări',
        //     value: 'formOperation.operationsE',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Parcelări',
        //     value: 'formOperation.operationsF',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Comasări',
        //     value: 'formOperation.operationsG',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Partaje',
        //     value: 'formOperation.operationsH',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Succesiuni',
        //     value: 'formOperation.operationsI',
        //     type: 'boolean',
        // },
        // {
        //     label: 'Altele',
        //     value: 'formOperation.operationsJ',
        //     type: 'boolean',
        // },
        //229
    ],
    'emitere-certificat-urbanism': [
        { label: 'Licitații publice', value: 'auction_details' },
        { label: 'Număr Cadastral', value: 'numar_cadastral' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Scop', value: 'motivatie' },
        { label: 'Alte scopuri', value: 'other_motivation_details' },
        { label: 'Suprafață', value: 'suprafata' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
        { label: 'Cereri în justiție', value: 'justice_details', type: 'boolean' },

        // Checkboxes

        // Form Documentation
        {
            label: 'Lucrări de construire',
            value: 'formDocumentation.documentation11',
            type: 'boolean',
        },
        {
            label: 'Lucrări de desfiinţare',
            value: 'formDocumentation.documentation12',
            type: 'boolean',
        },
        // Form Documentation Options
        {
            label:
                'Lucrări de construire, reconstruire, consolidare, modificare, extindere, reabilitare, schimbare de destinaţie sau de reparare a construcţiilor de orice fel, precum şi a instalaţiilor aferente acestora, cu excepţia celor prevăzute la art. 12 din Legea nr. 50/1991',
            value: 'formDocumentationOptions.documentationA',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, extindere, reparare, consolidare, protejare, restaurare, conservare, precum și orice alte lucrări, indiferent de valoarea lor, care urmează să fie efectuate la construcții reprezentând monumente istorice, stabilite potrivit legii',
            value: 'formDocumentationOptions.documentationB',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, modificare, extindere, reparare, modernizare și reabilitare privind căile de comunicație de orice fel, drumurile forestiere, lucrările de artă, rețelele și dotările tehnico-edilitare, lucrările hidrotehnice, amenajările de albii, lucrările de îmbuntățiri funciare, lucrările de instalații de infrastructură, lucrările pentru noi capacități de producere, transport, distribuție a energiei electrice și/sau termice, precum și de reabilitare și retehnologizare a celor existente',
            value: 'formDocumentationOptions.documentationC',
            type: 'boolean',
        },
        {
            label:
                'Împrejmuiri și mobilier urban, amenajări de spații verzi, parcuri, piețe și alte lucrări de amenajare a spațiilor publice',
            value: 'formDocumentationOptions.documentationD',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de foraje și excavări necesare pentru efectuarea studiilor geotehnice și a prospecțiunilor geologice, proiectarea și deschiderea exploatărilor de cariere și balastiere, a sondelor de gaze și petrol, precum și a altor exploatări de suprafață sau subterane',
            value: 'formDocumentationOptions.documentationE',
            type: 'boolean',
        },
        {
            label:
                'Lucrări, amenajări și construcții cu caracter provizoriu, necesare în vederea organizării executării lucrărilor, în condițiile prevăzute la art. 7 alin. (11) din Legea nr. 50/1991',
            value: 'formDocumentationOptions.documentationF',
            type: 'boolean',
        },
        {
            label: 'Organizarea de tabere de corturi, căsuțe sau rulote',
            value: 'formDocumentationOptions.documentationG',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construcții cu caracter provizoriu, chioșcuri, tonete, cabine, spații de expunere situate pe căile și spațiile publice, corpuri și panouri de afișaj, firme și reclame, precum și anexele gospodarești ale exploatațiilor agricole situate în extravilan',
            value: 'formDocumentationOptions.documentationH',
            type: 'boolean',
        },
        {
            label: 'Cimitire - noi și extinderi',
            value: 'formDocumentationOptions.documentationI',
            type: 'boolean',
        },
        //Form Operation
        {
            label: 'Vânzări',
            value: 'formOperation.operationsA',
            type: 'boolean',
        },
        {
            label: 'Cumpărări',
            value: 'formOperation.operationsB',
            type: 'boolean',
        },
        {
            label: 'Concesionări',
            value: 'formOperation.operationsC',
            type: 'boolean',
        },
        {
            label: 'Cesionări',
            value: 'formOperation.operationsD',
            type: 'boolean',
        },
        {
            label: 'Dezmembrări',
            value: 'formOperation.operationsE',
            type: 'boolean',
        },
        {
            label: 'Parcelări',
            value: 'formOperation.operationsF',
            type: 'boolean',
        },
        {
            label: 'Comasări',
            value: 'formOperation.operationsG',
            type: 'boolean',
        },
        {
            label: 'Partaje',
            value: 'formOperation.operationsH',
            type: 'boolean',
        },
        {
            label: 'Succesiuni',
            value: 'formOperation.operationsI',
            type: 'boolean',
        },
        {
            label: 'Altele',
            value: 'formOperation.operationsJ',
            type: 'boolean',
        },

        //216
    ],
    'emitere-acord-admin-drum': [
        { label: 'Categoria construcției', value: 'categoria_constructiei' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Carte funciară', value: 'extras_carte_funciara' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Număr aviz tehnic', value: 'numar_aviz_tehnic' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
        { label: 'Alte avize/acorduri', value: 'aviza_acorduri' },

        // Checkboxes

        // Form Anexe
        {
            label:
                'Avizul tehnic de branșare/racordare al administratorului/deținătorului de rețea',
            value: 'formAnexe.avizTehnicBransare',
            type: 'boolean',
        },
        {
            label: 'Număr aviz tehnic de branșare/racordare',
            value: 'formAnexe.anexa1NumarAvizTehnic',
        },
        {
            label: 'Plan de încadrare în zonă a lucrărilor',
            value: 'formAnexe.planIncadrare',
            type: 'boolean',
        },
        {
            label: 'Plan topografic scara 1:500 cu rețelele tehnico-edilitare',
            value: 'formAnexe.planTopografic',
            type: 'boolean',
        },
        {
            label:
                'Extras de carte funciară, actualizat la zi, al imobilului ce urmează a fi branșat/racordat',
            value: 'formAnexe.extrasCarteFunciara',
            type: 'boolean',
        },
        {
            label: 'Dovada deținerii imobilului',
            value: 'formAnexe.dovadaDetinereImobil',
            type: 'boolean',
        },
        {
            label:
                'Avizele administratorilor/deținătorilor de rețele tehnico-edilitare existente în zonă',
            value: 'formAnexe.avizAdminReteaTehnicoEdilitare',
            type: 'boolean',
        },
        {
            label: 'Alte avize/acorduri',
            value: 'formAnexe.alteAvizeAcorduri',
            type: 'boolean',
        },
        {
            label: 'Alte avize/acorduri denumire',
            value: 'formAnexe.alteAvizeAcorduriText',
        },
        {
            label:
                'Contractul de execuție a lucrării încheiat cu administratorul/deținătorul rețelei tehnico-edilitare',
            value: 'formAnexe.contractExecutie',
            type: 'boolean',
        },
        {
            label: 'Contract refacere pavaje',
            value: 'formAnexe.contractRefacerePavaje',
            type: 'boolean',
        },
        {
            label:
                'Graficul de execuție vizat de administratorul/deținătorul rețelei tehnico-edilitare',
            value: 'formAnexe.graficExecutieVizat',
            type: 'boolean',
        },
        {
            label: 'Memoriu tehnic',
            value: 'formAnexe.memoriuTehnic',
            type: 'boolean',
        },
        {
            label:
                'Documentația tehnică privind autorizarea executării lucrărilor de construcții',
            value: 'formAnexe.docTehnicAutorizareaExecutarii',
            type: 'boolean',
        },
        {
            label:
                'Referatele de verificare a documentaţiei privind asigurarea cerinţelor esenţiale de calitate în construcţii',
            value: 'formAnexe.referateVerificareDoc',
            type: 'boolean',
        },
        {
            label: 'Categoria de importanță a construcției',
            value: 'formAnexe.anexa14CategoriaConstructiei',
        },
        {
            label: 'Documentele de plată a taxelor legale în vederea autorizării',
            value: 'formAnexe.docPlataTaxelorLegale',
            type: 'boolean',
        },
        //228
    ],
    'admitere-atestare-edificare': [
        { label: 'Număr recepție', value: 'nr_receptie' },
        { label: 'Dată recepție', value: 'data_receptie', type: 'date' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Scop', value: 'motivatie' },
        //Checkboxes

        //Form Documentation
        {
            label: 'Edificarea construcției este realizată în conformitate cu:',
            value: 'formDocumentation.selectedOption',
        },

        //Form Documentation Options
        {
            label: 'Număr recepție finală',
            value: 'formDocumentationOptions.receptieFinalaNr',
        },
        {
            label: 'Dată recepție finală',
            value: 'formDocumentationOptions.receptieFinalaData',
            type: 'date',
        },
        //227
    ],
    'solicitare-participare-comisie': [
        // { label: 'Carte funciară', value: 'carte_funciara' },
        // { label: 'Număr autorizație', value: 'numar_autorizatie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        // 225
    ],
    'regularizare-taxa-reala': [
        {
            label: 'Autorizație construcție / Desființare construcție',
            value: 'acad',
        },
        { label: 'Eliberat în data de', value: 'acad_date' },
        {
            label: 'Valoarea reală a lucrărilor la finalizarea execuției',
            value: 'valoare_reala',
        },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        // 224
    ],
    'prelungire-valabilitate-autorizatie': [
        {
            label: 'Dată autorizație',
            value: 'data_autorizatie',
            type: 'date',
        },
        { label: 'Număr autorizație', value: 'numar_autorizatie' },
        {
            label: 'Dată documentație tehnică',
            value: 'data_documentatie_tehnica',
            type: 'date',
        },
        {
            label: 'Număr documentație tehnică',
            value: 'numar_documentatie_tehnica',
        },
        {
            label: 'Dată memoriu justificativ',
            value: 'data_memoriu_justificativ',
            type: 'date',
        },
        {
            label: 'Număr memoriu justificativ',
            value: 'numar_memoriu_justificativ',
        },
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        // 222
    ],
    'dispozitie-de-santier': [
        { label: 'Dată începere', value: 'data_incepere', type: 'date' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Plan cadastral', value: 'plan_cadastral' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Scop', value: 'motivatie' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
        // 221
    ],
    'prelungire-valabilitate-urbanism': [
        {
            label: 'Certificat urbanism',
            value: 'certificat_u',
        },
        {
            label: 'Dată certificat urbanism',
            value: 'data_certificat_u',
            type: 'date',
        },
        {
            label: 'Dată începere',
            value: 'data_incepere',
            type: 'date',
        },
        {
            label: 'Dată încheiere',
            value: 'data_incheiere',
            type: 'date',
        },
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        {
            label: 'Pentru construcție',
            value: 'pentru_constructie',
            type: 'boolean',
        },
        { label: 'Pentru teren', value: 'pentru_teren', type: 'boolean' },
        // 220
    ],
    'autorizatie-construire-desfiintare': [
        // Cerinte
        { label: 'Cerința A', value: 'cerinta_A' },
        { label: 'Cerința Af', value: 'cerinta_Af' },
        { label: 'Cerința B', value: 'cerinta_B' },
        { label: 'Cerința C', value: 'cerinta_C' },
        { label: 'Cerința D', value: 'cerinta_D' },
        { label: 'Cerința E', value: 'cerinta_E' },
        { label: 'Cerința F', value: 'cerinta_F' },
        { label: 'Cerința G', value: 'cerinta_G' },
        // Derivate Cerinte D
        {
            label: 'Avize și acorduri privind utilitățile urbane și infrastructura',
            value: 'cerinta_D1',
        },
        {
            label:
                'Avize și acorduri privind securitatea la incendiu, protecția civilă, sănătatea populației',
            value: 'cerinta_D2',
        },
        {
            label:
                'Avize/acorduri specifice ale administrației publice centrale și/sau ale serviciilor descentralizate ale acestora',
            value: 'cerinta_D3',
        },
        { label: 'Studii de specialitate', value: 'cerinta_D4' },
        {
            label:
                'Raport de expertiză tehnică pentru lucrări de intervenție la construcții existente - consolidare, modificare, extindere, reabilitare, schimbare de destinaţie, după caz',
            value: 'cerinta_D5',
        },
        {
            label:
                'Raport de audit energetic pentru lucrări de intervenție la clădiri existente în vederea creșterii performanței energetice şi/sau pentru lucrări de renovare majoră, după caz',
            value: 'cerinta_D6',
        },
        {
            label:
                'Referatele de verificare a documentației privind asigurarea cerințelor esențiale de calitate în construcții, corespunzător categoriei de importanță a construcției',
            value: 'cerinta_D7',
        },
        // Certificate & date
        { label: 'Certificat urbanism', value: 'certificat_u' },
        {
            label: 'Dată certificat urbanism',
            value: 'data_certificat_u',
            type: 'date',
        },
        {
            label: 'Număr documentație tehnică',
            value: 'numar_documentatie_tehnica',
        },
        {
            label: 'Dată documentație tehnică',
            value: 'data_documentatie_tehnica',
            type: 'date',
        },
        { label: 'Coeficientul de utilizare a terenului', value: 'cut_propus' },
        { label: 'Procentul de ocupare a terenului', value: 'pot_propus' },
        //Arhitect
        { label: 'Arhitect', value: 'nume_arhitect' },
        { label: 'Număr arhitect', value: 'numar_arhitect' },
        { label: 'Filială teritorială', value: 'filiata_arhitect' },

        //Common
        { label: 'Observații', value: 'observatii' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Număr cadastral', value: 'numar_cadastral' },
        { label: 'Timp de execuție', value: 'timp_executie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },

        //Calculator
        { label: 'Metoda de plată', value: 'metoda_plata' },

        { label: 'Autorizație de demolare', value: 'autorizatie_demolare', type: 'boolean' },
        { label: 'Organizare execuție lucrări', value: 'organizare_santier', type: 'boolean' },
        { label: 'Autorizație de construire', value: 'autorizatie_construire', type: 'boolean' },
        { label: 'Tip autorizație de construire', value: 'tip_autorizatie_construire' },
        { label: 'Tip clădiri PF - autorizație de construire', value: 'tip_cladire_PF' },
        { label: 'Instalații clădiri PF - autorizație de construire', value: 'tip_instalatii_PF' },

        { label: 'Valoare zona fiscală - autorizație de construire', value: 'zona_fiscala_value' },
        { label: 'Suprafață desfășurată - autorizație de construire', value: 'supraf_construire_value' },

        { label: 'Valoare deviz - autorizație de construire', value: 'suma_introdusa_construire' },
        { label: 'Suma introdusă - autorizație de demolare', value: 'suma_introdusa_demolare' },
        { label: 'Suma introdusă - organizare execuție lucrări', value: 'suma_introdusa_santier' },

        { label: 'Valoare de plată pentru autorizația de demolare', value: 'payment_autorizatie_demolare' },
        { label: 'Valoare de plată pentru organizare execuție lucrări', value: 'payment_organizare_santier' },
        { label: 'Valoare de plată pentru autorizația de construire', value: 'payment_autorizatie_construire' },
        { label: 'Total de plată', value: 'total_amount_autorizatie' },

        // Checkboxes

        // Form Anexa
        {
            label:
                'Lucrări de construire, reconstruire, consolidare, modificare, extindere, reabilitare, schimbare de destinaţie sau de reparare a construcţiilor de orice fel, precum şi a instalaţiilor aferente acestora, cu excepţia celor prevăzute la art. 12 din Legea nr. 50/1991',
            value: 'formAnexa.chapter1A',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, extindere, reparare, consolidare, protejare, restaurare, conservare, precum și orice alte lucrări, indiferent de valoarea lor, care urmează să fie efectuate la construcții reprezentând monumente istorice, stabilite potrivit legii',
            value: 'formAnexa.chapter1B',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, modificare, extindere, reparare, modernizare și reabilitare privind căile de comunicație de orice fel, drumurile forestiere, lucrările de artă, rețelele și dotările tehnico-edilitare, lucrările hidrotehnice, amenajările de albii, lucrările de îmbuntățiri funciare, lucrările de instalații de infrastructură, lucrările pentru noi capacități de producere, transport, distribuție a energiei electrice și/sau termice, precum și de reabilitare și retehnologizare a celor existente',
            value: 'formAnexa.chapter1C',
            type: 'boolean',
        },
        {
            label:
                'Împrejmuiri și mobilier urban, amenajări de spații verzi, parcuri, piețe și alte lucrări de amenajare a spațiilor publice',
            value: 'formAnexa.chapter1D',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de foraje și excavări necesare pentru efectuarea studiilor geotehnice și a prospecțiunilor geologice, proiectarea și deschiderea exploatărilor de cariere și balastiere, a sondelor de gaze și petrol, precum și a altor exploatări de suprafață sau subterane',
            value: 'formAnexa.chapter1E',
            type: 'boolean',
        },
        {
            label:
                'Lucrări, amenajări și construcții cu caracter provizoriu, necesare în vederea organizării executării lucrărilor, în condițiile prevăzute la art. 7 alin. (11) din Legea nr. 50/1991',
            value: 'formAnexa.chapter1F',
            type: 'boolean',
        },
        {
            label: 'Organizarea de tabere de corturi, căsuțe sau rulote',
            value: 'formAnexa.chapter1G',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construcții cu caracter provizoriu, chioșcuri, tonete, cabine, spații de expunere situate pe căile și spațiile publice, corpuri și panouri de afișaj, firme și reclame, precum și anexele gospodarești ale exploatațiilor agricole situate în extravilan',
            value: 'formAnexa.chapter1H',
            type: 'boolean',
        },
        {
            label: 'Cimitire - noi și extinderi',
            value: 'formAnexa.chapter1I',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de desființare a construcțiilor prevăzute de la lit. a) - h).',
            value: 'formAnexa.chapter1J',
            type: 'boolean',
        },
        {
            label: 'Administrație și finanțe',
            value: 'formAnexa.chapter2Administratie',
            type: 'boolean',
        },
        {
            label: 'Construcții agricole și zootehnice',
            value: 'formAnexa.chapter2Agricole',
            type: 'boolean',
        },
        {
            label: 'Amenajarea și consolidarea terenului',
            value: 'formAnexa.chapter2Amenajarea',
            type: 'boolean',
        },
        {
            label: 'Apă',
            value: 'formAnexa.chapter2Apa',
            type: 'boolean',
        },
        {
            label: 'Asistență socială',
            value: 'formAnexa.chapter2Asistenta',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexa.chapter2Canalizare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter provizoriu',
            value: 'formAnexa.chapter2CaracterProv',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter special',
            value: 'formAnexa.chapter2Caracter',
            type: 'boolean',
        },
        {
            label: 'Comerț',
            value: 'formAnexa.chapter2Comert',
            type: 'boolean',
        },
        {
            label: 'Culte',
            value: 'formAnexa.chapter2Culte',
            type: 'boolean',
        },
        {
            label: 'Cultură',
            value: 'formAnexa.chapter2Cultura',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru depozitare',
            value: 'formAnexa.chapter2Depozitare',
            type: 'boolean',
        },
        {
            label: 'Rețele edilitare',
            value: 'formAnexa.chapter2Edilitare',
            type: 'boolean',
        },
        {
            label: 'Construcții energetice',
            value: 'formAnexa.chapter2Energetice',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexa.chapter2Energie',
            type: 'boolean',
        },
        {
            label: 'Amenajări exterioare',
            value: 'formAnexa.chapter2Exterioare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu funcțiuni comasate',
            value: 'formAnexa.chapter2Functiuni',
            type: 'boolean',
        },
        {
            label: 'Gaze',
            value: 'formAnexa.chapter2Gaze',
            type: 'boolean',
        },
        {
            label: 'Construcții hidrotehnice',
            value: 'formAnexa.chapter2Hidrotehnice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru îmbunătățiri funciare',
            value: 'formAnexa.chapter2Imbunatatiri',
            type: 'boolean',
        },
        {
            label: 'Construcții industriale',
            value: 'formAnexa.chapter2Industrial',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru instituții publice și servicii',
            value: 'formAnexa.chapter2Institutii',
            type: 'boolean',
        },
        {
            label: 'Învățământ',
            value: 'formAnexa.chapter2Invatamant',
            type: 'boolean',
        },
        {
            label: 'Construcții de locuințe',
            value: 'formAnexa.chapter2Locuinte',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru pompieri',
            value: 'formAnexa.chapter2Pompieri',
            type: 'boolean',
        },
        {
            label: 'Recreere',
            value: 'formAnexa.chapter2Recreere',
            type: 'boolean',
        },
        {
            label: 'Sănătate',
            value: 'formAnexa.chapter2Sanatate',
            type: 'boolean',
        },
        {
            label: 'Servicii',
            value: 'formAnexa.chapter2Servicii',
            type: 'boolean',
        },
        {
            label: 'Spații libere și mobilier exterior',
            value: 'formAnexa.chapter2SpatiiLibere',
            type: 'boolean',
        },
        {
            label: 'Spații verzi, împrejmuiri',
            value: 'formAnexa.chapter2SpatiiVerzi',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexa.chapter2Sport',
            type: 'boolean',
        },
        {
            label: 'Străzi, alei, platforme, parcaje, garaje',
            value: 'formAnexa.chapter2Strazi',
            type: 'boolean',
        },
        {
            label: 'Construcții tehnico-edilitare',
            value: 'formAnexa.chapter2Tehnico',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru telecomunicații',
            value: 'formAnexa.chapter2TelecomConstr',
            type: 'boolean',
        },
        {
            label: 'Telecomunicații',
            value: 'formAnexa.chapter2TelecomRetele',
            type: 'boolean',
        },
        {
            label: 'Termice',
            value: 'formAnexa.chapter2Termice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru transporturi',
            value: 'formAnexa.chapter2Transporturi',
            type: 'boolean',
        },
        {
            label: 'Turism',
            value: 'formAnexa.chapter2Turism',
            type: 'boolean',
        },
        // Form Anexa L -> T
        {
            label: 'Apă',
            value: 'formAnexaPointLT.chapter3LCheckApa',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexaPointLT.chapter3LCheckCanal',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexaPointLT.chapter3LCheckElect',
            type: 'boolean',
        },
        {
            label: 'Gaze naturale',
            value: 'formAnexaPointLT.chapter3LCheckGaze',
            type: 'boolean',
        },
        {
            label: 'Salubritate',
            value: 'formAnexaPointLT.chapter3LCheckSalub',
            type: 'boolean',
        },
        {
            label: 'Telefonie',
            value: 'formAnexaPointLT.chapter3LCheckTel',
            type: 'boolean',
        },
        {
            label: 'Energie termică',
            value: 'formAnexaPointLT.chapter3LCheckTermic',
            type: 'boolean',
        },
        {
            label: 'Transport urban',
            value: 'formAnexaPointLT.chapter3LCheckTransp',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexaPointLT.chapter3MCheck1',
            type: 'boolean',
        },
        //219
    ],
    'construction-dem-retele-tehnico-edilitare': [
        // Cerinte
        { label: 'Cerința A', value: 'cerinta_A' },
        { label: 'Cerința Af', value: 'cerinta_Af' },
        { label: 'Cerința B', value: 'cerinta_B' },
        { label: 'Cerința C', value: 'cerinta_C' },
        { label: 'Cerința D', value: 'cerinta_D' },
        { label: 'Cerința E', value: 'cerinta_E' },
        { label: 'Cerința F', value: 'cerinta_F' },
        { label: 'Cerința G', value: 'cerinta_G' },
        // Derivate Cerinte D
        {
            label: 'Avize și acorduri privind utilitățile urbane și infrastructura',
            value: 'cerinta_D1',
        },
        {
            label:
                'Avize și acorduri privind securitatea la incendiu, protecția civilă, sănătatea populației',
            value: 'cerinta_D2',
        },
        {
            label:
                'Avize/acorduri specifice ale administrației publice centrale și/sau ale serviciilor descentralizate ale acestora',
            value: 'cerinta_D3',
        },
        { label: 'Studii de specialitate', value: 'cerinta_D4' },
        {
            label:
                'Raport de expertiză tehnică pentru lucrări de intervenție la construcții existente - consolidare, modificare, extindere, reabilitare, schimbare de destinaţie, după caz',
            value: 'cerinta_D5',
        },
        {
            label:
                'Raport de audit energetic pentru lucrări de intervenție la clădiri existente în vederea creșterii performanței energetice şi/sau pentru lucrări de renovare majoră, după caz',
            value: 'cerinta_D6',
        },
        {
            label:
                'Referatele de verificare a documentației privind asigurarea cerințelor esențiale de calitate în construcții, corespunzător categoriei de importanță a construcției',
            value: 'cerinta_D7',
        },
        // Certificate & date
        { label: 'Certificat urbanism', value: 'certificat_u' },
        {
            label: 'Dată certificat urbanism',
            value: 'data_certificat_u',
            type: 'date',
        },
        {
            label: 'Număr documentație tehnică',
            value: 'numar_documentatie_tehnica',
        },
        {
            label: 'Dată documentație tehnică',
            value: 'data_documentatie_tehnica',
            type: 'date',
        },
        { label: 'Coeficientul de utilizare a terenului', value: 'cut_propus' },
        { label: 'Procentul de ocupare a terenului', value: 'pot_propus' },
        //Arhitect
        { label: 'Arhitect', value: 'nume_arhitect' },
        { label: 'Număr arhitect', value: 'numar_arhitect' },
        { label: 'Filială teritorială', value: 'filiata_arhitect' },
        //Common
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Observații', value: 'observatii' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Număr cadastral', value: 'numar_cadastral' },
        { label: 'Timp de execuție', value: 'timp_executie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },

        // Checkboxes

        // Form Anexa
        {
            label:
                'Lucrări de construire, reconstruire, consolidare, modificare, extindere, reabilitare, schimbare de destinaţie sau de reparare a construcţiilor de orice fel, precum şi a instalaţiilor aferente acestora, cu excepţia celor prevăzute la art. 12 din Legea nr. 50/1991',
            value: 'formAnexa.chapter1A',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, extindere, reparare, consolidare, protejare, restaurare, conservare, precum și orice alte lucrări, indiferent de valoarea lor, care urmează să fie efectuate la construcții reprezentând monumente istorice, stabilite potrivit legii',
            value: 'formAnexa.chapter1B',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, modificare, extindere, reparare, modernizare și reabilitare privind căile de comunicație de orice fel, drumurile forestiere, lucrările de artă, rețelele și dotările tehnico-edilitare, lucrările hidrotehnice, amenajările de albii, lucrările de îmbuntățiri funciare, lucrările de instalații de infrastructură, lucrările pentru noi capacități de producere, transport, distribuție a energiei electrice și/sau termice, precum și de reabilitare și retehnologizare a celor existente',
            value: 'formAnexa.chapter1C',
            type: 'boolean',
        },
        {
            label:
                'Împrejmuiri și mobilier urban, amenajări de spații verzi, parcuri, piețe și alte lucrări de amenajare a spațiilor publice',
            value: 'formAnexa.chapter1D',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de foraje și excavări necesare pentru efectuarea studiilor geotehnice și a prospecțiunilor geologice, proiectarea și deschiderea exploatărilor de cariere și balastiere, a sondelor de gaze și petrol, precum și a altor exploatări de suprafață sau subterane',
            value: 'formAnexa.chapter1E',
            type: 'boolean',
        },
        {
            label:
                'Lucrări, amenajări și construcții cu caracter provizoriu, necesare în vederea organizării executării lucrărilor, în condițiile prevăzute la art. 7 alin. (11) din Legea nr. 50/1991',
            value: 'formAnexa.chapter1F',
            type: 'boolean',
        },
        {
            label: 'Organizarea de tabere de corturi, căsuțe sau rulote',
            value: 'formAnexa.chapter1G',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construcții cu caracter provizoriu, chioșcuri, tonete, cabine, spații de expunere situate pe căile și spațiile publice, corpuri și panouri de afișaj, firme și reclame, precum și anexele gospodarești ale exploatațiilor agricole situate în extravilan',
            value: 'formAnexa.chapter1H',
            type: 'boolean',
        },
        {
            label: 'Cimitire - noi și extinderi',
            value: 'formAnexa.chapter1I',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de desființare a construcțiilor prevăzute de la lit. a) - h).',
            value: 'formAnexa.chapter1J',
            type: 'boolean',
        },
        {
            label: 'Administrație și finanțe',
            value: 'formAnexa.chapter2Administratie',
            type: 'boolean',
        },
        {
            label: 'Construcții agricole și zootehnice',
            value: 'formAnexa.chapter2Agricole',
            type: 'boolean',
        },
        {
            label: 'Amenajarea și consolidarea terenului',
            value: 'formAnexa.chapter2Amenajarea',
            type: 'boolean',
        },
        {
            label: 'Apă',
            value: 'formAnexa.chapter2Apa',
            type: 'boolean',
        },
        {
            label: 'Asistență socială',
            value: 'formAnexa.chapter2Asistenta',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexa.chapter2Canalizare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter provizoriu',
            value: 'formAnexa.chapter2CaracterProv',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter special',
            value: 'formAnexa.chapter2Caracter',
            type: 'boolean',
        },
        {
            label: 'Comerț',
            value: 'formAnexa.chapter2Comert',
            type: 'boolean',
        },
        {
            label: 'Culte',
            value: 'formAnexa.chapter2Culte',
            type: 'boolean',
        },
        {
            label: 'Cultură',
            value: 'formAnexa.chapter2Cultura',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru depozitare',
            value: 'formAnexa.chapter2Depozitare',
            type: 'boolean',
        },
        {
            label: 'Rețele edilitare',
            value: 'formAnexa.chapter2Edilitare',
            type: 'boolean',
        },
        {
            label: 'Construcții energetice',
            value: 'formAnexa.chapter2Energetice',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexa.chapter2Energie',
            type: 'boolean',
        },
        {
            label: 'Amenajări exterioare',
            value: 'formAnexa.chapter2Exterioare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu funcțiuni comasate',
            value: 'formAnexa.chapter2Functiuni',
            type: 'boolean',
        },
        {
            label: 'Gaze',
            value: 'formAnexa.chapter2Gaze',
            type: 'boolean',
        },
        {
            label: 'Construcții hidrotehnice',
            value: 'formAnexa.chapter2Hidrotehnice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru îmbunătățiri funciare',
            value: 'formAnexa.chapter2Imbunatatiri',
            type: 'boolean',
        },
        {
            label: 'Construcții industriale',
            value: 'formAnexa.chapter2Industrial',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru instituții publice și servicii',
            value: 'formAnexa.chapter2Institutii',
            type: 'boolean',
        },
        {
            label: 'Învățământ',
            value: 'formAnexa.chapter2Invatamant',
            type: 'boolean',
        },
        {
            label: 'Construcții de locuințe',
            value: 'formAnexa.chapter2Locuinte',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru pompieri',
            value: 'formAnexa.chapter2Pompieri',
            type: 'boolean',
        },
        {
            label: 'Recreere',
            value: 'formAnexa.chapter2Recreere',
            type: 'boolean',
        },
        {
            label: 'Sănătate',
            value: 'formAnexa.chapter2Sanatate',
            type: 'boolean',
        },
        {
            label: 'Servicii',
            value: 'formAnexa.chapter2Servicii',
            type: 'boolean',
        },
        {
            label: 'Spații libere și mobilier exterior',
            value: 'formAnexa.chapter2SpatiiLibere',
            type: 'boolean',
        },
        {
            label: 'Spații verzi, împrejmuiri',
            value: 'formAnexa.chapter2SpatiiVerzi',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexa.chapter2Sport',
            type: 'boolean',
        },
        {
            label: 'Străzi, alei, platforme, parcaje, garaje',
            value: 'formAnexa.chapter2Strazi',
            type: 'boolean',
        },
        {
            label: 'Construcții tehnico-edilitare',
            value: 'formAnexa.chapter2Tehnico',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru telecomunicații',
            value: 'formAnexa.chapter2TelecomConstr',
            type: 'boolean',
        },
        {
            label: 'Telecomunicații',
            value: 'formAnexa.chapter2TelecomRetele',
            type: 'boolean',
        },
        {
            label: 'Termice',
            value: 'formAnexa.chapter2Termice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru transporturi',
            value: 'formAnexa.chapter2Transporturi',
            type: 'boolean',
        },
        {
            label: 'Turism',
            value: 'formAnexa.chapter2Turism',
            type: 'boolean',
        },
        // Form Anexa L -> T
        {
            label: 'Apă',
            value: 'formAnexaPointLT.chapter3LCheckApa',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexaPointLT.chapter3LCheckCanal',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexaPointLT.chapter3LCheckElect',
            type: 'boolean',
        },
        {
            label: 'Gaze naturale',
            value: 'formAnexaPointLT.chapter3LCheckGaze',
            type: 'boolean',
        },
        {
            label: 'Salubritate',
            value: 'formAnexaPointLT.chapter3LCheckSalub',
            type: 'boolean',
        },
        {
            label: 'Telefonie',
            value: 'formAnexaPointLT.chapter3LCheckTel',
            type: 'boolean',
        },
        {
            label: 'Energie termică',
            value: 'formAnexaPointLT.chapter3LCheckTermic',
            type: 'boolean',
        },
        {
            label: 'Transport urban',
            value: 'formAnexaPointLT.chapter3LCheckTransp',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexaPointLT.chapter3MCheck1',
            type: 'boolean',
        },
        //219
    ],
    'construction-dem-mijloace-publicitare': [
        // Cerinte
        { label: 'Cerința A', value: 'cerinta_A' },
        { label: 'Cerința Af', value: 'cerinta_Af' },
        { label: 'Cerința B', value: 'cerinta_B' },
        { label: 'Cerința C', value: 'cerinta_C' },
        { label: 'Cerința D', value: 'cerinta_D' },
        { label: 'Cerința E', value: 'cerinta_E' },
        { label: 'Cerința F', value: 'cerinta_F' },
        { label: 'Cerința G', value: 'cerinta_G' },
        // Derivate Cerinte D
        {
            label: 'Avize și acorduri privind utilitățile urbane și infrastructura',
            value: 'cerinta_D1',
        },
        {
            label:
                'Avize și acorduri privind securitatea la incendiu, protecția civilă, sănătatea populației',
            value: 'cerinta_D2',
        },
        {
            label:
                'Avize/acorduri specifice ale administrației publice centrale și/sau ale serviciilor descentralizate ale acestora',
            value: 'cerinta_D3',
        },
        { label: 'Studii de specialitate', value: 'cerinta_D4' },
        {
            label:
                'Raport de expertiză tehnică pentru lucrări de intervenție la construcții existente - consolidare, modificare, extindere, reabilitare, schimbare de destinaţie, după caz',
            value: 'cerinta_D5',
        },
        {
            label:
                'Raport de audit energetic pentru lucrări de intervenție la clădiri existente în vederea creșterii performanței energetice şi/sau pentru lucrări de renovare majoră, după caz',
            value: 'cerinta_D6',
        },
        {
            label:
                'Referatele de verificare a documentației privind asigurarea cerințelor esențiale de calitate în construcții, corespunzător categoriei de importanță a construcției',
            value: 'cerinta_D7',
        },
        // Certificate & date
        { label: 'Certificat urbanism', value: 'certificat_u' },
        {
            label: 'Dată certificat urbanism',
            value: 'data_certificat_u',
            type: 'date',
        },
        {
            label: 'Număr documentație tehnică',
            value: 'numar_documentatie_tehnica',
        },
        {
            label: 'Dată documentație tehnică',
            value: 'data_documentatie_tehnica',
            type: 'date',
        },
        { label: 'Coeficientul de utilizare a terenului', value: 'cut_propus' },
        { label: 'Procentul de ocupare a terenului', value: 'pot_propus' },
        //Arhitect
        { label: 'Arhitect', value: 'nume_arhitect' },
        { label: 'Număr arhitect', value: 'numar_arhitect' },
        { label: 'Filială teritorială', value: 'filiata_arhitect' },
        //Common
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Observații', value: 'observatii' },
        { label: 'Extras carte funciară', value: 'extras_carte_funciara' },
        { label: 'Număr cadastral', value: 'numar_cadastral' },
        { label: 'Timp de execuție', value: 'timp_executie' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },

        // Checkboxes

        // Form Anexa
        {
            label:
                'Lucrări de construire, reconstruire, consolidare, modificare, extindere, reabilitare, schimbare de destinaţie sau de reparare a construcţiilor de orice fel, precum şi a instalaţiilor aferente acestora, cu excepţia celor prevăzute la art. 12 din Legea nr. 50/1991',
            value: 'formAnexa.chapter1A',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, extindere, reparare, consolidare, protejare, restaurare, conservare, precum și orice alte lucrări, indiferent de valoarea lor, care urmează să fie efectuate la construcții reprezentând monumente istorice, stabilite potrivit legii',
            value: 'formAnexa.chapter1B',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construire, reconstruire, modificare, extindere, reparare, modernizare și reabilitare privind căile de comunicație de orice fel, drumurile forestiere, lucrările de artă, rețelele și dotările tehnico-edilitare, lucrările hidrotehnice, amenajările de albii, lucrările de îmbuntățiri funciare, lucrările de instalații de infrastructură, lucrările pentru noi capacități de producere, transport, distribuție a energiei electrice și/sau termice, precum și de reabilitare și retehnologizare a celor existente',
            value: 'formAnexa.chapter1C',
            type: 'boolean',
        },
        {
            label:
                'Împrejmuiri și mobilier urban, amenajări de spații verzi, parcuri, piețe și alte lucrări de amenajare a spațiilor publice',
            value: 'formAnexa.chapter1D',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de foraje și excavări necesare pentru efectuarea studiilor geotehnice și a prospecțiunilor geologice, proiectarea și deschiderea exploatărilor de cariere și balastiere, a sondelor de gaze și petrol, precum și a altor exploatări de suprafață sau subterane',
            value: 'formAnexa.chapter1E',
            type: 'boolean',
        },
        {
            label:
                'Lucrări, amenajări și construcții cu caracter provizoriu, necesare în vederea organizării executării lucrărilor, în condițiile prevăzute la art. 7 alin. (11) din Legea nr. 50/1991',
            value: 'formAnexa.chapter1F',
            type: 'boolean',
        },
        {
            label: 'Organizarea de tabere de corturi, căsuțe sau rulote',
            value: 'formAnexa.chapter1G',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de construcții cu caracter provizoriu, chioșcuri, tonete, cabine, spații de expunere situate pe căile și spațiile publice, corpuri și panouri de afișaj, firme și reclame, precum și anexele gospodarești ale exploatațiilor agricole situate în extravilan',
            value: 'formAnexa.chapter1H',
            type: 'boolean',
        },
        {
            label: 'Cimitire - noi și extinderi',
            value: 'formAnexa.chapter1I',
            type: 'boolean',
        },
        {
            label:
                'Lucrări de desființare a construcțiilor prevăzute de la lit. a) - h).',
            value: 'formAnexa.chapter1J',
            type: 'boolean',
        },
        {
            label: 'Administrație și finanțe',
            value: 'formAnexa.chapter2Administratie',
            type: 'boolean',
        },
        {
            label: 'Construcții agricole și zootehnice',
            value: 'formAnexa.chapter2Agricole',
            type: 'boolean',
        },
        {
            label: 'Amenajarea și consolidarea terenului',
            value: 'formAnexa.chapter2Amenajarea',
            type: 'boolean',
        },
        {
            label: 'Apă',
            value: 'formAnexa.chapter2Apa',
            type: 'boolean',
        },
        {
            label: 'Asistență socială',
            value: 'formAnexa.chapter2Asistenta',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexa.chapter2Canalizare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter provizoriu',
            value: 'formAnexa.chapter2CaracterProv',
            type: 'boolean',
        },
        {
            label: 'Construcții cu caracter special',
            value: 'formAnexa.chapter2Caracter',
            type: 'boolean',
        },
        {
            label: 'Comerț',
            value: 'formAnexa.chapter2Comert',
            type: 'boolean',
        },
        {
            label: 'Culte',
            value: 'formAnexa.chapter2Culte',
            type: 'boolean',
        },
        {
            label: 'Cultură',
            value: 'formAnexa.chapter2Cultura',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru depozitare',
            value: 'formAnexa.chapter2Depozitare',
            type: 'boolean',
        },
        {
            label: 'Rețele edilitare',
            value: 'formAnexa.chapter2Edilitare',
            type: 'boolean',
        },
        {
            label: 'Construcții energetice',
            value: 'formAnexa.chapter2Energetice',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexa.chapter2Energie',
            type: 'boolean',
        },
        {
            label: 'Amenajări exterioare',
            value: 'formAnexa.chapter2Exterioare',
            type: 'boolean',
        },
        {
            label: 'Construcții cu funcțiuni comasate',
            value: 'formAnexa.chapter2Functiuni',
            type: 'boolean',
        },
        {
            label: 'Gaze',
            value: 'formAnexa.chapter2Gaze',
            type: 'boolean',
        },
        {
            label: 'Construcții hidrotehnice',
            value: 'formAnexa.chapter2Hidrotehnice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru îmbunătățiri funciare',
            value: 'formAnexa.chapter2Imbunatatiri',
            type: 'boolean',
        },
        {
            label: 'Construcții industriale',
            value: 'formAnexa.chapter2Industrial',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru instituții publice și servicii',
            value: 'formAnexa.chapter2Institutii',
            type: 'boolean',
        },
        {
            label: 'Învățământ',
            value: 'formAnexa.chapter2Invatamant',
            type: 'boolean',
        },
        {
            label: 'Construcții de locuințe',
            value: 'formAnexa.chapter2Locuinte',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru pompieri',
            value: 'formAnexa.chapter2Pompieri',
            type: 'boolean',
        },
        {
            label: 'Recreere',
            value: 'formAnexa.chapter2Recreere',
            type: 'boolean',
        },
        {
            label: 'Sănătate',
            value: 'formAnexa.chapter2Sanatate',
            type: 'boolean',
        },
        {
            label: 'Servicii',
            value: 'formAnexa.chapter2Servicii',
            type: 'boolean',
        },
        {
            label: 'Spații libere și mobilier exterior',
            value: 'formAnexa.chapter2SpatiiLibere',
            type: 'boolean',
        },
        {
            label: 'Spații verzi, împrejmuiri',
            value: 'formAnexa.chapter2SpatiiVerzi',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexa.chapter2Sport',
            type: 'boolean',
        },
        {
            label: 'Străzi, alei, platforme, parcaje, garaje',
            value: 'formAnexa.chapter2Strazi',
            type: 'boolean',
        },
        {
            label: 'Construcții tehnico-edilitare',
            value: 'formAnexa.chapter2Tehnico',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru telecomunicații',
            value: 'formAnexa.chapter2TelecomConstr',
            type: 'boolean',
        },
        {
            label: 'Telecomunicații',
            value: 'formAnexa.chapter2TelecomRetele',
            type: 'boolean',
        },
        {
            label: 'Termice',
            value: 'formAnexa.chapter2Termice',
            type: 'boolean',
        },
        {
            label: 'Construcții pentru transporturi',
            value: 'formAnexa.chapter2Transporturi',
            type: 'boolean',
        },
        {
            label: 'Turism',
            value: 'formAnexa.chapter2Turism',
            type: 'boolean',
        },
        // Form Anexa L -> T
        {
            label: 'Apă',
            value: 'formAnexaPointLT.chapter3LCheckApa',
            type: 'boolean',
        },
        {
            label: 'Canalizare',
            value: 'formAnexaPointLT.chapter3LCheckCanal',
            type: 'boolean',
        },
        {
            label: 'Energie electrică',
            value: 'formAnexaPointLT.chapter3LCheckElect',
            type: 'boolean',
        },
        {
            label: 'Gaze naturale',
            value: 'formAnexaPointLT.chapter3LCheckGaze',
            type: 'boolean',
        },
        {
            label: 'Salubritate',
            value: 'formAnexaPointLT.chapter3LCheckSalub',
            type: 'boolean',
        },
        {
            label: 'Telefonie',
            value: 'formAnexaPointLT.chapter3LCheckTel',
            type: 'boolean',
        },
        {
            label: 'Energie termică',
            value: 'formAnexaPointLT.chapter3LCheckTermic',
            type: 'boolean',
        },
        {
            label: 'Transport urban',
            value: 'formAnexaPointLT.chapter3LCheckTransp',
            type: 'boolean',
        },
        {
            label: 'Sport',
            value: 'formAnexaPointLT.chapter3MCheck1',
            type: 'boolean',
        },
        //219
    ],
    'aviz-primar': [
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        // 78
    ],
    'avizare-aprobare-documentatie-urbanism': [
        { label: 'Metoda de plată', value: 'metoda_plata' },
        { label: 'Taxă achitată', value: 'taxa_achitata' },
        { label: 'Creat la', value: 'created_at', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', type: 'date' },
        // 72
    ],
};
